var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-dialog",
        { attrs: { "max-width": "1000px", persistent: "", value: true } },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.$t("travelService.orderCar")))
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c(
                        "fieldset",
                        { staticClass: "custom-fieldset" },
                        [
                          _c("order-user-select", {
                            attrs: {
                              value:
                                _vm.contextModel
                                  .travelServiceOrderItemPassengers[0],
                              "birth-date-required":
                                _vm.$store.getters["userProperties"]
                                  .system_settings
                                  .travel_service_car_insurance ===
                                _vm.insuranceTypeID.INSURANCE_ADD
                            },
                            on: {
                              "update:value": function($event) {
                                return _vm.$set(
                                  _vm.contextModel
                                    .travelServiceOrderItemPassengers,
                                  0,
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.carClass,
                                  label: _vm.$t("travelService.carClass") + "*",
                                  rules: [_vm.validatorIsRequired]
                                },
                                model: {
                                  value:
                                    _vm.contextModel.travelServiceOrderItemCar
                                      .car_class,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemCar,
                                      "car_class",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contextModel.travelServiceOrderItemCar.car_class"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("location-ajax-select", {
                                attrs: {
                                  label:
                                    _vm.$t("travelService.pickupPlace") + "*",
                                  placeholder: _vm.$t(
                                    "travelService.enterCountry"
                                  ),
                                  rules: [
                                    function(v) {
                                      return (
                                        (v != null && v.length > 0) ||
                                        _vm.$t("global.error.required")
                                      )
                                    }
                                  ],
                                  "select-model":
                                    _vm.contextModel.travelServiceOrderItemCar
                                      .start_place_id
                                },
                                on: {
                                  "update:selectModel": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemCar,
                                      "start_place_id",
                                      $event
                                    )
                                  },
                                  "update:select-model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemCar,
                                      "start_place_id",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("date-picker", {
                                attrs: {
                                  label:
                                    _vm.$t("travelService.pickupDate") + "*",
                                  max:
                                    _vm.contextModel.travelServiceOrderItemCar
                                      .end_date,
                                  model:
                                    _vm.contextModel.travelServiceOrderItemCar
                                      .start_date,
                                  rules: [
                                    _vm.validatorIsRequired,
                                    _vm.validatorIsFutureDate
                                  ]
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemCar,
                                      "start_date",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("time-picker", {
                                attrs: {
                                  label: _vm.$t("travelService.pickupTime"),
                                  model:
                                    _vm.contextModel.travelServiceOrderItemCar
                                      .start_time,
                                  placeholder: _vm.$t("travelService.any"),
                                  "prepend-icon": ""
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemCar,
                                      "start_time",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("date-picker", {
                                attrs: {
                                  label:
                                    _vm.$t("travelService.returnCarDate") + "*",
                                  min:
                                    _vm.contextModel.travelServiceOrderItemCar
                                      .start_date,
                                  model:
                                    _vm.contextModel.travelServiceOrderItemCar
                                      .end_date,
                                  rules: [
                                    _vm.validatorIsRequired,
                                    _vm.validatorIsFutureDate
                                  ]
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemCar,
                                      "end_date",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("time-picker", {
                                attrs: {
                                  label: _vm.$t("travelService.returnCarTime"),
                                  model:
                                    _vm.contextModel.travelServiceOrderItemCar
                                      .end_time,
                                  placeholder: _vm.$t("travelService.any"),
                                  "prepend-icon": ""
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemCar,
                                      "end_time",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: _vm.$t(
                                    "travelService.returnDifferentPlace"
                                  )
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.cleanEndLocation($event)
                                  }
                                },
                                model: {
                                  value: _vm.otherEndLocation,
                                  callback: function($$v) {
                                    _vm.otherEndLocation = $$v
                                  },
                                  expression: "otherEndLocation"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.otherEndLocation
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "px-2",
                                  attrs: { cols: "12", sm: "6" }
                                },
                                [
                                  _c("location-ajax-select", {
                                    attrs: {
                                      label:
                                        _vm.$t("travelService.returnCarPlace") +
                                        "*",
                                      placeholder: _vm.$t(
                                        "travelService.enterCountry"
                                      ),
                                      rules: [_vm.validatorIsRequired],
                                      "select-model":
                                        _vm.contextModel
                                          .travelServiceOrderItemCar
                                          .end_place_id
                                    },
                                    on: {
                                      "update:selectModel": function($event) {
                                        return _vm.$set(
                                          _vm.contextModel
                                            .travelServiceOrderItemCar,
                                          "end_place_id",
                                          $event
                                        )
                                      },
                                      "update:select-model": function($event) {
                                        return _vm.$set(
                                          _vm.contextModel
                                            .travelServiceOrderItemCar,
                                          "end_place_id",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("cost-centre-select", {
                                attrs: { value: _vm.contextModel.cost_centre },
                                on: {
                                  "update:value": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel,
                                      "cost_centre",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "px-2", attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: _vm.$t("global.comment") },
                                model: {
                                  value: _vm.contextModel.comment,
                                  callback: function($$v) {
                                    _vm.$set(_vm.contextModel, "comment", $$v)
                                  },
                                  expression: "contextModel.comment"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cancel($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: !_vm.formValid,
                        color: "blue darken-1",
                        text: ""
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save($event)
                        }
                      }
                    },
                    [_vm._v("Ok")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }